{
  "scripts": {
    "https://request.eprotect.vantivprelive.com/eProtect/eProtect-api3.js": "sha384-VM96ZnWRJL1Ez7nVX13O5k0nAYPXEL56O5CZJgzmzo+UkXbnyQljUv07JTX9HiEf",
    "https://request.eprotect.vantivcnp.com/eProtect/eProtect-api3.js": "sha384-zxWVyaMBCd5gyhThAswKLt5VcdXl/Cps1iXlGqt/2zC28/tcLUX+F2sEaB6qOTGQ"
  }
}